export default function TwitchIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.149 0L.537 4.119v16.836h5.731V24h3.224l3.045-3.045h4.657L23.463 14.61V0H2.149zm19.164 13.612l-3.582 3.582h-5.731l-3.045 3.045v-3.045H4.119V2.149h17.194v11.463zM18.806 5.731v6.448h-2.149V5.731h2.149zm-5.731 0v6.448h-2.149V5.731h2.149z" />
    </svg>
  );
}
